import { Redirect } from 'expo-router';

export default function FruitfulCardFAQScreen() {
    return <Redirect href="/settings/faq" />;
}
